import {Stack, Typography} from "@mui/material";
import type {IntelligenceResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, Sel, SummaryPill, SummaryPillRow, rowSx, set, type ResolverEditorProps} from "./ResolverUtils.tsx";

function IntelligenceEditor({draft, editing, onChange}: ResolverEditorProps & { draft: IntelligenceResolver }) {
    if (!editing) {
        return (
            <Stack direction="column" spacing={0.5} sx={{alignItems: "center", width: "100%"}}>
                <SummaryPillRow>
                    <SummaryPill label="Intel Type" value={draft.intelType}/>
                    <SummaryPill label="Definition" value={draft.definition}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="Display" value={draft.display}/>
                    <SummaryPill label="Match Hash" value={draft.matchHash}/>
                </SummaryPillRow>
            </Stack>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <Sel value={draft.intelType} label="Intelligence Type" onChange={(v) => upd("intelType", v)} options={[
                    {value: "SELECTOR", label: "Selector"},
                    {value: "ENTITY", label: "Entity"},
                    {value: "EVENT", label: "Event"},
                    {value: "ACTIVITY", label: "Activity"},
                ]}/>
                <Sel value={draft.definition} label="Definition" onChange={(v) => upd("definition", v)} minWidth="160px" options={[
                    {value: "NET.EMAIL_ADDRESS", label: "NET.EMAIL_ADDRESS"},
                    {value: "NET.IP_ADDRESS", label: "NET.IP_ADDRESS"},
                    {value: "NET.DOMAIN", label: "NET.DOMAIN"},
                    {value: "NET.URL", label: "NET.URL"},
                    {value: "PERSON.NAME", label: "PERSON.NAME"},
                    {value: "PERSON.ID", label: "PERSON.ID"},
                ]}/>
            </Stack>
            <Stack direction="row" sx={rowSx}>
                <Typography sx={{color: "#38ff82", fontSize: "0.70rem"}}>{draft.display || "N/A"}</Typography>
                <Typography sx={{color: "rgba(242, 245, 250, 0.4)", fontSize: "0.60rem", fontFamily: "monospace"}}>{draft.matchHash || "N/A"}</Typography>
            </Stack>
        </Stack>
    );
}

export default IntelligenceEditor;
